import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const navLinks = [
  { href: "#galeri", label: "Galeri" },
  { href: "#adimlar", label: "Nasıl Çalışır?" },
  { href: "#ozellikler", label: "Özellikler" },
  { href: "#yorumlar", label: "Yorumlar" },
  { href: "#sss", label: "SSS" },
  { href: "/iletisim", label: "İletişim" },
];

export default function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBannerOpen, setIsBannerOpen] = useState(true);
  const logoSrc = (process.env.PUBLIC_URL || "") + "/logo.png";

  return (
    <header className="fixed top-0 w-full z-50 flex flex-col">
      {/* Duyuru Çubuğu Banner (Pop-up Popüler Çubuk) */}
      {isBannerOpen && (
        <div className="relative bg-gradient-to-r from-rose-400 via-[#e45078] to-orange-400 text-white text-center py-2.5 px-10 shadow-md flex items-center justify-center gap-3 animate-in slide-in-from-top duration-500">
          <span className="text-xs sm:text-sm md:text-base font-medium tracking-wide flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            🎉 Anora ile en özel gününüz ölümsüzleşsin! Kısa süreliğine <strong className="font-bold">1.200 TL</strong>'den başlayan fiyatlarla.
            <span className="inline-flex items-center gap-1 bg-white/25 border border-white/40 px-2.5 py-0.5 rounded-full text-xs sm:text-sm font-bold shadow-sm whitespace-nowrap">
              💳 3 Taksit İmkanı!
            </span>
            <Link to="/paketler" className="inline-flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 px-3 py-1 transition-colors font-bold shadow-sm text-xs sm:text-sm whitespace-nowrap">
              Paketlere Gözat ➔
            </Link>
          </span>
          <button
            onClick={() => setIsBannerOpen(false)}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all"
            aria-label="Kapat"
          >
            <X className="w-4 h-4 md:w-5 md:h-5" />
          </button>
        </div>
      )}

      {/* Main Nav Bar */}
      <div className="backdrop-blur supports-[backdrop-filter]:bg-white/70 bg-white/90 border-b border-white/40 shadow-sm w-full">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group" aria-label="Anora ana sayfa">
            <span className="size-12 md:size-16 rounded-2xl bg-rose-500/10 ring-1 ring-rose-200/50 relative overflow-hidden grid place-items-center">
              <img
                src={logoSrc}
                alt="Anora"
                className="w-[44px] h-[44px] md:w-[60px] md:h-[60px] object-contain"
                aria-hidden
              />
            </span>
            <span className="font-semibold tracking-tight text-2xl text-gray-800">
              <span className="text-[#e45078] font-cormorant font-bold text-3xl">Anora</span>
            </span>
          </Link>

          {/* Masaüstü Navigasyon */}
          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="relative text-neutral-800/90 font-medium hover:text-rose-700 transition-colors after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0 after:bg-rose-500 hover:after:w-full after:transition-all"
              >
                {link.label}
              </a>
            ))}
            {/* Paketler - Özel Vurgulu Buton */}
            <Link
              to="/paketler"
              className="relative inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-gradient-to-r from-rose-400 to-[#e45078] text-white text-sm font-bold shadow-md hover:shadow-lg hover:from-rose-500 hover:to-rose-600 transition-all duration-300 hover:-translate-y-0.5 group"
            >
              <span className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-10 transition-opacity"></span>
              ✨ Paketler
            </Link>

            {/* Ücretsiz Demo Butonu */}
            <Link
              to="/owner/login"
              className="relative inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-gradient-to-r from-purple-500 to-[#e45078] text-white text-sm font-bold shadow-md hover:shadow-lg hover:from-purple-600 hover:to-rose-600 transition-all duration-300 hover:-translate-y-0.5 group"
            >
              <span className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-10 transition-opacity"></span>
              🚀 Ücretsiz Demo
            </Link>
          </nav>

          {/* Masaüstü Giriş Butonu */}
          <div className="hidden sm:flex items-center relative group">
            <Button className="h-10 px-5 text-sm font-semibold rounded-xl bg-[#e45078] hover:bg-rose-600 text-white shadow-sm hover:shadow-md transition-shadow">
              Giriş Yap
            </Button>

            {/* Açılır Menü (Dropdown) */}
            <div className="absolute top-1/2 right-0 pt-10 w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
              <div className="bg-white border border-rose-100 shadow-xl rounded-xl flex flex-col overflow-hidden">
                <Link to="/owner/login" className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-rose-50 hover:text-[#e45078] border-b border-gray-100 transition-colors">
                  🤵👰 Bireysel Giriş
                </Link>
                <Link to="/organization/login" className="px-4 py-3 text-sm font-medium text-gray-700 hover:bg-rose-50 hover:text-[#e45078] transition-colors">
                  🏢 Kurumsal Giriş
                </Link>
              </div>
            </div>
          </div>

          {/* Mobil Menü Butonu */}
          <button
            className="md:hidden inline-flex items-center justify-center rounded-xl p-2.5 hover:bg-rose-50"
            onClick={() => setIsMenuOpen(true)}
            aria-label="Menüyü aç"
          >
            <Menu className="w-7 h-7" />
          </button>
        </div>
      </div>

      {/* Mobil Açılır Menü */}
      <div
        className={`fixed inset-0 z-[60] md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? "pointer-events-auto" : "pointer-events-none"
          }`}
      >
        {/* Arka plan karartma */}
        <div
          className={`absolute inset-0 bg-black/25 backdrop-blur-sm transition-opacity duration-300 ${isMenuOpen ? "opacity-100" : "opacity-0"
            }`}
          onClick={() => setIsMenuOpen(false)}
          aria-hidden
        />

        {/* Sağdan kayan menü */}
        <div
          className={`absolute right-0 top-0 h-full w-[68%] max-w-[420px] bg-white shadow-2xl p-6 flex flex-col gap-6 rounded-l-2xl transform transition-transform duration-300 ease-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"
            }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="size-10 rounded-2xl bg-rose-500/10 grid place-items-center ring-1 ring-rose-200/50">
                <img
                  src={logoSrc}
                  alt="Anora"
                  className="w-8 h-8 object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </span>
              <span className="font-semibold tracking-tight text-xl">
                <span className="text-[#e45078] font-cormorant font-bold text-2xl">Anora</span>
              </span>
            </div>
            <button
              className="rounded-xl p-2.5 hover:bg-rose-50"
              onClick={() => setIsMenuOpen(false)}
              aria-label="Menüyü kapat"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          <nav className="flex flex-col gap-3 mt-4">
            <Link
              to="/paketler"
              onClick={() => setIsMenuOpen(false)}
              className="rounded-lg px-3 py-3 text-lg font-semibold text-[#e45078] hover:bg-rose-50 transition-all flex items-center gap-2"
            >
              ✨ Paketler
            </Link>
            <Link
              to="/owner/login"
              onClick={() => setIsMenuOpen(false)}
              className="rounded-xl px-4 py-3 text-lg font-bold text-white bg-gradient-to-r from-purple-600 to-rose-500 hover:from-purple-700 hover:to-rose-600 shadow-md transition-all flex items-center justify-center gap-2 cursor-pointer"
            >
              🚀 Ücretsiz Demo
            </Link>
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setIsMenuOpen(false)}
                className="rounded-lg px-3 py-3.5 text-lg font-medium text-gray-800 hover:bg-rose-50 hover:text-rose-600 transition-all"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="mt-auto sm:hidden flex flex-col gap-3">
            <div className="text-center text-sm font-medium text-gray-400 mb-1">GİRİŞ YAP</div>
            <Link to="/owner/login" className="block" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full h-12 text-base font-semibold rounded-xl bg-[#e45078] hover:bg-rose-600 text-white shadow-md hover:shadow-lg transition-all">
                🤵👰 Bireysel Giriş
              </Button>
            </Link>
            <Link to="/organization/login" className="block" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full h-12 text-base font-semibold rounded-xl bg-white border-2 border-[#e45078] text-[#e45078] hover:bg-rose-50 shadow-sm transition-all">
                🏢 Kurumsal Giriş
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
